export function LilDragonsSparringTabContent() {
  return (
    <div className="mt-10">
      <h3 className="text-lg font-semibold text-taekwondo-red mb-4">Non-Contact Sparring</h3>
      <div className="bg-white rounded-lg p-4 md:p-6 shadow-sm flex flex-col md:flex-row items-center gap-4">
        <img
          src="/images/dragons/dragon_sparring.PNG"
          alt="Lil' Dragon non-contact sparring"
          className="h-28 w-auto flex-shrink-0"
          loading="lazy"
          decoding="async"
        />
        <p className="text-sm text-gray-700 text-left">
          Non-contact sparring is pretend fighting where we use our{" "}
          <span className="font-semibold">best blocks, kicks, and punches</span> but stop before we touch our
          partner.
          <br /> <br />
          We learn to keep the <span className="font-semibold">right distance</span>, aim carefully, and show{" "}
          <span className="font-semibold">kindness and control</span> so everyone stays safe and has fun.
          <br />
          <br /> This exercise helps us get ready for real sparring when we are older, while still being gentle
          dragons today.
        </p>
      </div>
    </div>
  );
}
